import { module } from 'modujs';
import { html } from '../utils/environment';
// import { inertElements } from '../utils/inertElements';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'toggler': 'toggle',
                'close': 'close',
                'link': 'close'
            }
        }

        // Inert
        // this.elementsToUnfocus = ['.c-page']
        // this.elementsToFocus = ['.c-header']
    }

    init() {
        this.$expand = this.$('expand')[0];
        this.$inner = this.$('inner')[0];

        this.bindEvents();
    }

    ////////////////////
    // Events
    ////////////////////
    bindEvents() {
        this.resizeBind = this.onResize.bind(this);
        window.addEventListener('resize', this.resizeBind);

        this.closeBind = (e) => {
            if (e.key === "Escape") {
               this.close();
           }
       }

       document.addEventListener('keyup', this.closeBind);
    }

    ////////////////////
    // Methods
    ////////////////////

    toggle() {
        if(html.classList.contains('has-header-open')) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        const height = this.computeHeight(this.$expand) + 60;

        html.classList.add('has-header-open');
        this.$inner.style.setProperty('--header-height', `${height}px`);

        this.$expand.setAttribute('aria-expanded', 'true');

        // inertElements(this.elementsToUnfocus, true);

        // inertElements(this.elementsToFocus, false);
    }

    close() {
        html.classList.remove('has-header-open');

        this.$expand.setAttribute('aria-expanded', 'false');

        // inertElements(this.elementsToUnfocus, false);

        // inertElements(this.elementsToFocus, false);
    }

    computeHeight($el) {
        return $el.getBoundingClientRect().height;
    }

    onResize() {
        const height = this.computeHeight(this.$expand) + 60;
        this.$inner.style.setProperty('--header-height', `${height}px`);
    }

    destroy() {
        super.destroy();
        window.removeEventListener('resize', this.resizeBind);
        document.removeEventListener('keyup', this.closeBind);
    }
}
